var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-logo-box df jcc aic"},[_c('img',{staticClass:"d-logo",style:({ height: _vm.height }),attrs:{"alt":"home","src":_vm.src},on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }